import axiosInstance from "../axiosInstance";

export const kafkaDeadLetterService = {
  fetch: async (limit, skip, filters = {}) => {
    const params = new URLSearchParams({
      $limit: limit || 15,
      $skip: skip || 0,
      "$sort[lastFailedAt]": -1,
    });
    if (filters.topic) params.append("topic", filters.topic);
    if (filters.status) params.append("status", filters.status);
    const response = await axiosInstance.get(
      `/kafka-dead-letter?${params.toString()}`,
    );
    return response.data;
  },

  retrigger: async (id) => {
    const response = await axiosInstance.patch(`/kafka-dead-letter/${id}`, {
      status: "reprocessing",
      lastRetriggeredAt: new Date(),
    });
    return response.data;
  },

  resolve: async (id) => {
    const response = await axiosInstance.patch(`/kafka-dead-letter/${id}`, {
      status: "resolved",
      resolvedAt: new Date(),
    });
    return response.data;
  },

  fetchTopics: async () => {
    const response = await axiosInstance.get(
      `/kafka-dead-letter?$limit=200&$sort[topic]=1`,
    );
    const topics = [
      ...new Set((response.data?.data || []).map((r) => r.topic)),
    ];
    return topics;
  },
};
